import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-booking-plans-package-content',
  templateUrl: './booking-plans-package-content.component.html',
  styleUrls: ['./booking-plans-package-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingPlansPackageContentComponent {
  @Input() isLegacyDevice = false;
  @Input() isVoucherContent = false;
}
